<template>
  <section-vue class="teams-hero">
    <div class="teams-hero__container container">
      <div class="teams-hero__content">
        <h1 class="teams-hero__headline">
          {{ $t("headline", { maxSeats }) }}
        </h1>

        <div class="teams-hero__subheadline">
          {{ $t("subheadline") }}
        </div>

        <buy-button event-category="body-20210217-business_teams_hero" />

        <a
          class="teams-hero__faq-link"
          href="#faq"
          v-html="$t('faq')"
          event-category="body-20210217-business_teams_hero"
          event-name="faq"
        />
      </div>

      <pict
        block-name="teams-hero"
        :default="{
          src: $options.image.l,
          srcset: {
            '2x': $options.image.l2x
          }
        }"
      />

      <div class="teams-hero__wave">
        <svg class="teams-hero__wave-svg" height="100%" viewBox="0 0 301 476" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M-6.10352e-05 476C-6.94348e-05 254.217 151.112 300.942 229.233 98.1504C244.854 52.6649 270.242 21.1938 301 3.05176e-05L301 476L-6.10352e-05 476Z"
            fill="#044063"
          />
        </svg>
      </div>
    </div>
  </section-vue>
</template>

<script>
import { mapState } from "vuex"

import SectionVue from "@/shared/section"
import Pict from "@/shared/pict"
import BuyButton from "./buy-button"
import imageL from "../images/teams-hero/teams-hero.jpg"
import imageL2x from "../images/teams-hero/teams-hero@2x.jpg"

export default {
  name: "TeamsHero",
  components: {
    SectionVue,
    Pict,
    BuyButton
  },
  image: {
    l: imageL,
    l2x: imageL2x
  },
  computed: {
    ...mapState("business", ["maxSeats"])
  },
  i18n: {
    messages: {
      en: {
        headline: "Blinkist for up to 200 people",
        subheadline: "Teams that learn together, grow together. Get started today with our self-serve Teams plan.",
        faq: "See our <mark>FAQ below</mark> for questions"
      },
      de: {
        headline: "Blinkist Teams für bis zu 200 Personen",
        subheadline:
          "Individuell Horizonte erweitern, gemeinsam wachsen. Ab einer Anzahl von 5 Personen profitieren kleinere Unternehmen und Lerngruppen von dem vergünstigten Angebot.",
        faq: 'Im unteren Bereich dieser Seite finden Sie <mark>„Häufig gestellte Fragen."</mark>'
      }
    }
  }
}
</script>

<style lang="scss">
.teams-hero {
  position: relative;

  overflow: hidden;

  &__container {
    @include media(min-width, m) {
      @include grid-css;
    }
  }

  &__content {
    position: relative;
    z-index: 3;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    margin-bottom: $spacing-32;

    @include media(min-width, m) {
      @include grid-css-element(6);
    }
  }

  &__headline {
    margin-bottom: $spacing-32;
  }

  &__subheadline {
    @include p0;

    margin-bottom: $spacing-32;
  }

  &__faq-link {
    @include font-style(legal);

    margin-top: $spacing-16;
  }

  mark {
    text-decoration: underline;

    cursor: pointer;
  }

  &__wave {
    position: absolute;
    bottom: 0;
    left: 50%;
    z-index: 1;

    display: flex;
    height: 100%;

    &:after {
      content: "";

      display: block;
      width: 100vw;
      height: 100%;
      margin-left: -1px;

      background: $midnight4;
    }

    @include media(min-width, m) {
      left: 45%;
    }
  }

  &__wave-svg {
    flex-shrink: 0;
    height: 100%;
  }

  &__picture {
    position: relative;
    z-index: 2;

    @include media(min-width, m) {
      @include grid-css-element(6);

      display: flex;
      align-items: center;
    }
  }

  &__image {
    width: 100%;

    border-radius: $border-radius-4;

    box-shadow: $spacing-8 $spacing-8 $white;
  }
}
</style>
